import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./fonts/Mina-Bold.ttf";
import "./fonts/Mina-Regular.ttf";
import "./fonts/Questrial-Regular.ttf";
import "./fonts/OriginalSurfer-Regular.ttf";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter as Router } from "react-router-dom";

ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
